function setup() {
  this.logger.log(`setup ${this.currentScene} scene`);
}

export { setup };
